export default __webpack_public_path__ + "static/media/kalahastiTemple5.36d1afe0.jpg";